import { groupSeriesByMinute } from './shared';

function getAeCount(seriesData) {
  return seriesData.reduce((max, serie) => Math.max(max, serie.no + 1), 0);
}

export default {
  buildFields(seriesData) {
    const aeCount = getAeCount(seriesData);
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      ...Array.from({ length: aeCount }, (_, i) => ({
        key: `ae${i + 1}`,
        label: `AE ${i + 1} Running Seconds`,
        class: 'text-center',
      })),
    ];
  },
  buildLogs(seriesData) {
    const aeCount = getAeCount(seriesData);
    const keys = Array.from({ length: aeCount }, (_, i) => `ae${i + 1}`);
    return groupSeriesByMinute(seriesData, keys, (row, serie) => {
      row[`ae${serie.no + 1}`] = serie.rpm;
    });
  },
  buildSummary(seriesData) {
    const aesTotal = [];
    seriesData.forEach((serie) => {
      if (aesTotal[serie.no] === undefined) {
        aesTotal[serie.no] = 0;
      }
      aesTotal[serie.no] += serie.rpm;
    });
    return aesTotal;
  },
};
